import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    itemPerPage: 5,
  },
  reducers: {
    login: (state, action) => {
      state.user = action.payload;
    },
    logout: (state) => {
      state.user = null;
    },
    setItemPerPage: (state, action) => {
      state.itemPerPage = action.payload;
    },
  },
});

export const { login, logout, setItemPerPage } = userSlice.actions;

// export const selectUser = (state) => state.user.user;

export default userSlice.reducer;
